import React from 'react'

const NavBar = () => {
  return (
    <div className="NavBar">
      <div className="buttonsection">
        <a href="#Home">
          <div className="button">
            Home
            <div className="line"></div>
          </div>
        </a>
        <a href="#About">
          <div className="button">
            About
            <div className="line"></div>
          </div>
        </a>
        <a href="#Project">
          <div className="button hideoncondition">
            Project
            <div className="line"></div>
          </div>
        </a>
        <a href="#Achievement">
          <div className="button">
            Achievement
            <div className="line"></div>
          </div>
        </a>

        <a href="#Skills" className="skillsbtn">
          <div className="button hideoncondition">
            Skills
            <div className="line"></div>
          </div>
        </a>
      </div>
    </div>
  );
}

export default NavBar
